// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.width-100[data-v-5db7f1fa]{\n  width: 100%;\n}\n.radio-group-total[data-v-5db7f1fa] .el-radio{\n  display: block;\n  line-height: 28px;\n}\n", ""]);
// Exports
module.exports = exports;
